import { FormCheckbox, LayoutGap } from '@gov-nx/ui/web';
import type { FormCheckboxProps } from '@gov-nx/ui/types';
import { useAuthorizationConsentField } from '@gov-nx/core/hooks';

interface SouhlasCheckboxProps {
	field?: FormCheckboxProps;
	show: boolean;
	disabled?: boolean;
}

export const SouhlasCheckbox = ({
	field,
	show,
	disabled = false,
}: SouhlasCheckboxProps) => {
	const defautConsentField = useAuthorizationConsentField(disabled);
	if (!show) {
		return null;
	}
	const consentField = field ? field : defautConsentField;

	return (
		<LayoutGap gap="m">
			<FormCheckbox {...consentField} />
		</LayoutGap>
	);
};
